import {Person} from 'core/domain';
import {Referral} from 'referral';

export enum OfferStatus {
    ACCEPTED = 'ACCEPTED',
    CANCELLED = 'CANCELLED',
    DECLINED = 'DECLINED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED',
    VOID = 'VOID'
}

// BHPNPP-1341, BHPNPP-2026 if any update here, please update backend too, to avoid error on saving to Salesforce
export const ServiceLocationTypeMap = new Map<string, string>([
    ['Home', 'Home'],
    ['ClinicCenter', 'Clinic/Center'],
    ['Community', 'Community'],
    ['Telehealth', 'Telehealth'],
    ['TelehealthAssessmentOnly', 'Telehealth - Assessment Only, Treatment in Person'],
    ['SchoolDayCare', 'School/Day Care'],
])

export type OfferContent = {
    serviceLocationType: string;
    serviceLocationParaprofessionalType: string;
    serviceLocationMidLevelType: string;
    serviceLocationHighLevelType: string;
    serviceLocationGroupCareType: string;
    provideServicesInClinic: boolean;
    clinic: Clinic | null;
    otherClinicLocation: string | null;

    provideServiceInRequiredLanguage: boolean;

    firstServiceDate: string | null;

    provideAllEstimatedHours: boolean;
    directCareHours: number | null;
    midLevelSupervisionHours: number | null;
    highLevelSupervisionHours: number | null;
    groupCareHours: number | null;
    lastServiceDate: string | null;
    treatmentOffered: string | null,
    caregiverMediatedMidLevelHours: number | null;
    caregiverMediatedHighLevelHours: number | null;
    psychotherapyOffer: number | null;
    startDateCaregiverMediatedTreatment: string | null,
    startDatePractMediatedTreatment: string | null,

    comments: string | null;
}

export type ConversationSummary = {
    urgent: boolean;
    hasConversation: boolean;
    providerUnreadCount: number;
    clientPlacementTeamUnreadCount: number;
};

export type Offer = {
    id: string;
    guid: string;
    status: OfferStatus;
    referral: Referral;
    submittedAt: string;
    submittedBy: Person;
    draftStaffingPlan: OfferStaffingPlan | null;
    originalOfferGuid: string | null;
    conversationSummary?: ConversationSummary | null;
    provider?: {
        guid: string;
        name: string;
    } | null;
} & OfferContent;

export type OfferStaffingPlan = {
    comments: string;
    fullOfferStartDate: string;
    reviewedAndApprovedByClientFamilyDate: string;
    offeredParaprofessionalHours: number | null;
    offeredMidLevelHours: number | null;
    offeredHighLevelHours: number | null;
    offeredGroupCareHours: number | null;
}

export type Clinic = {
    id: string;
    guid: string;
    location: string;
    street: string;
    city: string;
    stateCode: string;
    zipCode: string;
};
